import type { CrmHistoryEventMap } from '@/Containers/CrmSection/Components/History'

/**
 * Коди подій історії перевізника — рівно enum беку
 * `backend/web/src/Containers/CarrierContainer/Database/Enum/CarrierHistoryEvent.php`
 * (`SPEC-010` §12): по коду на кожен із 22 суфіксів ядра CRM `CrmHistoryEvent`,
 * власних подій понад ядро немає.
 *
 * Ключі — **буквальні** повні коди: мапу звіряє з беком вартовий «кожен код
 * події історії з бека має підпис на фронті»
 * (`Ship/Helpers/architectureGuard.test.ts`). Стрічка малює `label ?? event`,
 * тож код без підпису витік би користувачу голим.
 *
 * Підписи й тони — `SPEC-008` §5.5, ті самі, що в клієнта: кольорові лише
 * події, що міняють стан перевізника; правки, діти й файли — нейтральні.
 */
export const CARRIER_HISTORY_EVENT_MAP: CrmHistoryEventMap = {
    carrier_created: { label: 'Створено', tone: 'blue', kind: 'created' },
    carrier_updated: { label: 'Змінено дані', tone: 'neutral', kind: 'updated' },
    carrier_removed: { label: 'Видалено', tone: 'red', kind: 'removed' },
    carrier_status_changed: { label: 'Змінено статус', tone: 'purple', kind: 'status' },
    carrier_verification_sent: { label: 'Відправлено на верифікацію', tone: 'geekblue', kind: 'status' },
    carrier_verified: { label: 'Верифікацію підтверджено', tone: 'green', kind: 'status' },
    carrier_verification_rejected: { label: 'Верифікацію відхилено', tone: 'orange', kind: 'status' },
    carrier_blacklisted: { label: 'Додано до чорного списку', tone: 'red', kind: 'status' },
    carrier_unblacklisted: { label: 'Видалено з чорного списку', tone: 'green', kind: 'status' },
    carrier_contact_added: { label: 'Додано контакт', tone: 'neutral', kind: 'contact' },
    carrier_contact_updated: { label: 'Змінено контакт', tone: 'neutral', kind: 'contact' },
    carrier_contact_removed: { label: 'Видалено контакт', tone: 'neutral', kind: 'contact' },
    carrier_contract_added: { label: 'Додано договір', tone: 'neutral', kind: 'contract' },
    carrier_contract_updated: { label: 'Змінено договір', tone: 'neutral', kind: 'contract' },
    carrier_contract_removed: { label: 'Видалено договір', tone: 'neutral', kind: 'contract' },
    carrier_document_added: { label: 'Додано документ', tone: 'neutral', kind: 'document' },
    carrier_document_updated: { label: 'Змінено документ', tone: 'neutral', kind: 'document' },
    carrier_document_removed: { label: 'Видалено документ', tone: 'neutral', kind: 'document' },
    carrier_document_generated: { label: 'Згенеровано документ', tone: 'neutral', kind: 'document' },
    carrier_document_edited: { label: 'Документ змінено в редакторі', tone: 'neutral', kind: 'document' },
    carrier_file_attached: { label: 'Прикріплено файл', tone: 'neutral', kind: 'file' },
    carrier_file_removed: { label: 'Видалено файл', tone: 'neutral', kind: 'file' },
}
